/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {FruitsServerDataParser} from "../FruitsServerDataParser";
import {IFruitsParsedServerData} from "./FruitsParsedServerData";
import {IFruitsGameData} from "./IFruitsServerData";

export class FruitsParsedGameData extends SpinParsedGameData implements IFruitsParsedServerData {

    private _newOverlayStickySymbols:boolean[];
    private _overlayStickySymbolsBeforeSpin:boolean[];
    private _overlayStickySymbolsAfterSpin:boolean[];
    private _stickySymbol:string;
    private _bonusSpinsLeft:number;
    private _bonusSpinsPlayed:number;
    private _isBonusTriggeredThisSpin:boolean;
    private _bonusGameQueued:boolean;
    private _symbolOverlayPositions:boolean[][];
    private _randomSymbolOverlayTriggered:boolean;
    private _randomOverlaySymbol:string;
    private _numberOfOverlaySymbols:number;
    private _bonusOverlayPositionsBefore:boolean[][];
    private _bonusOverlayPositionsAfter:boolean[][];
    private _newBonusOverlayPositions:boolean[][];
    private _bonusSpecialSymbolMultiplier:boolean[][];
    private _bonusSpecialSymbolExtraSpin:boolean[][];
    private _currentBonusPaytable:number[];
    private _bonusPaytableBeforeSpin:number[];
    private _bonusPaytableAfterSpin:number[];
    private _numberOfUpgradesBefore:number;
    private _numberOfUpgradesAfter:number;
    private _numberOfUpgradesThisSpin:number;
    private _collectedScatterBefore:number;
    private _collectedScatterAfter:number;
    private _finalBonusWin:number;
    private _reelsEnteringBonus:string[][];
    private _upgradeTriggered:boolean;
    private _isStickyRespinTriggeredThisSpin:boolean;
    private _numberOfBonusSpinsPlayed:number;
    private _numberOfSpinsRemaining:number;
    private _isExcitementSpinTriggered:boolean;
    private _isExcitementSpinTriggeredPortrait:boolean;
    private _nearWinPositions:boolean[][];
    private _bigWinExcitementPositions:boolean[][];
    private _bigWinExcitementPositionsPortrait:boolean[][];
    private _nearWinPositionsPortrait:boolean[][];
    private _overlaySymbolsAfterSpin:string[][];
    private _overlaySymbolsBeforeSpin:string[][];
    private _parsedRandomOverlayPositions:number[];

    public get newOverlayStickySymbols():boolean[] {
        return this._newOverlayStickySymbols;
    }

    public get overlayStickySymbolsBeforeSpin():boolean[] {
        return this._overlayStickySymbolsBeforeSpin;
    }

    public get overlayStickySymbolsAfterSpin():boolean[] {
        return this._overlayStickySymbolsAfterSpin;
    }

    public get stickySymbol():string {
        return this._stickySymbol;
    }

    public get bonusSpinsLeft():number {
        return this._bonusSpinsLeft;
    }

    public get bonusSpinsPlayed():number {
        return this._bonusSpinsPlayed;
    }

    public get isBonusTriggeredThisSpin():boolean {
        return this._isBonusTriggeredThisSpin;
    }

    public get bonusGameQueued():boolean {
        return this._bonusGameQueued;
    }

    public get isStickyRespinTriggeredThisSpin():boolean {
        return this._isStickyRespinTriggeredThisSpin;
    }

    public get randomSymbolOverlayTriggered():boolean {
        return this._randomSymbolOverlayTriggered;
    }

    public get bonusOverlayPositionsBefore():boolean[][] {
        return this._bonusOverlayPositionsBefore;
    }

    public get bonusOverlayPositionsAfter():boolean[][] {
        return this._bonusOverlayPositionsAfter;
    }

    public get newBonusOverlayPositions():boolean[][] {
        return this._newBonusOverlayPositions;
    }

    public get symbolOverlayPositions():boolean[][] {
        return this._symbolOverlayPositions;
    }

    public get randomOverlaySymbol():string {
        return this._randomOverlaySymbol;
    }

    public get currentBonusPaytable():number[] {
        return this._currentBonusPaytable;
    }

    public get numberOfUpgradesBefore():number {
        return this._numberOfUpgradesBefore;
    }

    public get numberOfUpgradesAfter():number {
        return this._numberOfUpgradesAfter;
    }

    public get numberOfBonusSpinsPlayed():number {
        return this._numberOfBonusSpinsPlayed;
    }

    public get numberOfUpgradesThisSpin():number {
        return this._numberOfUpgradesThisSpin;
    }

    public get collectedScatterBefore():number {
        return this._collectedScatterBefore;
    }

    public get collectedScatterAfter():number {
        return this._collectedScatterAfter;
    }

    public get finalBonusWin():number {
        return this._finalBonusWin;
    }

    public get numberOfOverlaySymbols():number {
        return this._numberOfOverlaySymbols;
    }

    public get reelsEnteringBonus():string[][] {
        return this._reelsEnteringBonus;
    }

    public get bonusPayTableBeforeSpin():number[] {
        return this._bonusPaytableBeforeSpin;
    }

    public get bonusPayTableAfterSpin():number[] {
        return this._bonusPaytableAfterSpin;
    }

    public get upgradeTriggered():boolean {
        return this._upgradeTriggered;
    }

    public get bonusSpecialSymbolMultiplier():boolean[][] {
        return this._bonusSpecialSymbolMultiplier;
    }

    public get bonusSpecialSymbolExtraSpin():boolean[][] {
        return this._bonusSpecialSymbolExtraSpin;
    }

    public get nearWinPositions():boolean[][] {
        return this._nearWinPositions;
    }

    public get bigWinExcitementPositions():boolean[][] {
        return this._bigWinExcitementPositions;
    }

    public get nearWinPositionsPortrait():boolean[][] {
        return this._nearWinPositionsPortrait;
    }

    public get bigWinExcitementPositionsPortrait():boolean[][] {
        return this._bigWinExcitementPositionsPortrait;
    }

    public get overlaySymbolsBeforeSpin():string[][] {
        return this._overlaySymbolsBeforeSpin;
    }

    public get overlaySymbolsAfterSpin():string[][] {
        return this._overlaySymbolsAfterSpin;
    }

    public get isExcitementSpinTriggered():boolean {
        return this._isExcitementSpinTriggered;
    }

    public get isExcitementSpinTriggeredPortrait():boolean {
        return this._isExcitementSpinTriggeredPortrait;
    }

    public get numberOfSpinsRemaining():number {
        return this._numberOfSpinsRemaining;
    }

    protected isFeatureTotalWin():boolean {
        return this.mode === FruitsGameMode.STICKY_RESPIN || this.mode === FruitsGameMode.BONUS_GAME ||
            this.nextMode === FruitsGameMode.STICKY_RESPIN || this.nextMode === FruitsGameMode.BONUS_GAME;
    }

    protected isNextFeatureTotalWin():boolean {
        return this.nextMode === FruitsGameMode.STICKY_RESPIN || this.nextMode === FruitsGameMode.BONUS_GAME;
    }

    public get parsedRandomOverlayPositions():number[] {
        return this._parsedRandomOverlayPositions;
    }

    constructor(rawData:IFruitsGameData, dataParser:FruitsServerDataParser) {
        super(rawData, dataParser);

        this._newOverlayStickySymbols = dataParser.parseOverlayStickySymbols(rawData.newOverlayStickySymbols);
        this._overlayStickySymbolsBeforeSpin = dataParser.parseOverlayStickySymbols(rawData.overlayStickySymbolsBeforeSpin);
        this._overlayStickySymbolsAfterSpin = dataParser.parseOverlayStickySymbols(rawData.overlayStickySymbolsAfterSpin);
        this._parsedRandomOverlayPositions = dataParser.parseRandomOverlayPositions(rawData.symbolOverlayPositions);
        this._stickySymbol = dataParser.parseStickySymbol(rawData);
        this._bonusSpinsLeft = dataParser.parseBonusSpinsLeft(rawData);
        this._bonusSpinsPlayed = dataParser.parseBonusSpinsPlayed(rawData);
        this._isBonusTriggeredThisSpin = dataParser.parseIsBonusTriggeredThisSpin(rawData);
        this._isStickyRespinTriggeredThisSpin = dataParser.parseIsStickyRespinTriggeredThisSpin(rawData);
        this._symbolOverlayPositions = dataParser.parseSymbolOverlayPositions(rawData);
        this._randomSymbolOverlayTriggered = dataParser.parseRandomSymbolOverlayTriggered(rawData);
        this._randomOverlaySymbol = dataParser.parseRandomOverlaySymbol(rawData);
        this._numberOfOverlaySymbols = dataParser.parseNumberOfOverlaySymbols(rawData);
        this._numberOfBonusSpinsPlayed = dataParser.parseNumberOfBonusSpinsPlayed(rawData);
        this._bonusOverlayPositionsBefore = dataParser.parseBonusOverlayPositionsBefore(rawData);
        this._bonusOverlayPositionsAfter = dataParser.parseBonusOverlayPositionsAfter(rawData);
        this._newBonusOverlayPositions = dataParser.parseNewBonusOverlayPositions(rawData);
        this._currentBonusPaytable = dataParser.parseCurrentBonusPaytable(rawData);
        this._numberOfSpinsRemaining = dataParser.parseNumberOfSpinsRemaining(rawData);
        this._bonusPaytableBeforeSpin = dataParser.parseBonusPaytableBeforeSpin(rawData);
        this._bonusPaytableAfterSpin = dataParser.parseBonusPaytableAfterSpin(rawData);
        this._numberOfUpgradesBefore = dataParser.parseNumberOfUpgradesBefore(rawData);
        this._numberOfUpgradesAfter = dataParser.parseNumberOfUpgradesAfter(rawData);
        this._numberOfUpgradesThisSpin = dataParser.parseNumberOfUpgradesThisSpin(rawData);
        this._collectedScatterBefore = dataParser.parseCollectedScatterBefore(rawData);
        this._collectedScatterAfter = dataParser.parseCollectedScatterAfter(rawData);
        this._finalBonusWin = dataParser.parseFinalBonusWin(rawData);
        this._reelsEnteringBonus = dataParser.parseReelsEnteringBonus(rawData);
        this._upgradeTriggered = dataParser.parseUpgradeTriggered(rawData);
        this._bonusSpecialSymbolMultiplier = dataParser.parseBonusSpecialSymbolMultiplier(rawData);
        this._bonusSpecialSymbolExtraSpin = dataParser.parseBonusSpecialSymbolExtraSpin(rawData);
        this._isExcitementSpinTriggered = dataParser.parseIsExcitementSpinTriggered(rawData);
        this._nearWinPositions = dataParser.parseNearWinPositions(rawData);
        this._nearWinPositionsPortrait = dataParser.parseNearWinPositionsPortrait(rawData);
        this._bigWinExcitementPositions = dataParser.parseBigWinExcitementPositions(rawData);
        this._bigWinExcitementPositionsPortrait = dataParser.parseBigWinExcitementPositionsPortrait(rawData);
        this._overlaySymbolsBeforeSpin = dataParser.parseOverlaySymbolsBeforeSpin(rawData);
        this._overlaySymbolsAfterSpin = dataParser.parseOverlaySymbolsAfterSpin(rawData);
        this._bonusGameQueued = dataParser.parseBonusGameQueued(rawData);
    }
}